import { render, staticRenderFns } from "./ConfigCardModalContent.vue?vue&type=template&id=200e0a99&scoped=true"
import script from "./ConfigCardModalContent.vue?vue&type=script&lang=js"
export * from "./ConfigCardModalContent.vue?vue&type=script&lang=js"
import style0 from "./ConfigCardModalContent.vue?vue&type=style&index=0&id=200e0a99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e0a99",
  null
  
)

export default component.exports